export const lblBiaOrderHistoryMainTitle = 'lbl_bia_main_title';
export const ACCOUNT_COMMON_CONSTANT = 'account.common';

export const BIAOrderHistoryLabels = {
  account: {
    common: {
      [lblBiaOrderHistoryMainTitle]: 'Buy it Again',
    },
  },
};
